import React from "react";
import CronJobsTable from "../../../../Components/Tables/CronJobsTable/CronJobsTable";
import Loading from "../../../../Components/Loading";
import { Card, CardBody, Col } from "reactstrap";
import cronJobicon from "../../../../assets/images/iconsRoles/cronjobsIcon.svg";

const CronJobs = ({ data, paginationProps, loading }) => {
  return (
    <>
      <div className="col-12 d-flex flex-row align-items-center mt-2">
        <h2 htmlFor="like-input" className="form-label fw-bold">
          <img src={cronJobicon} alt="cronJobicon" className="me-3 ps-3" />
          Crons Jobs Executions
        </h2>
      </div>
      <Col xl={12}>
        <Card className="mb-0 ">
          <CardBody className="">
            <div className="table-container  position-relative">
              {loading && <Loading />}
              <div className="live-preview">
                <div className="table-responsive ">
                  <CronJobsTable
                    data={data}
                    paginationProps={paginationProps}
                  />
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default CronJobs;
